/* file description */
/* file description */

import { valueReplace } from '@/asset/AssetTask/service';
import { transformCopyValue } from '@/asset/AssetTask/templates/Cascade/effect';
import { EventType, FunParamsType } from '@/asset/types';
import useMetaStore from '@/store/useMetaStore';
import useValuesStore from '@/store/useValuesStore';
import { message } from 'antd';
import { useEffect } from 'react';
import _ from 'lodash';
import { useSetState } from 'ahooks';


export interface EsConfigType extends EventType {
  /** 点击跳转参数 */
  toDetailPage?: boolean;
  openType?: 'tab' | 'spa' | 'drawer';
  openUrl?: string;
  tooltipText?: string;
  openIcon?: string;

  /** 复制参数 */
  mapField?: string;
  copyCode?: string;
  copyId?: string;
  copyMap?: Record<string, any>;
}


export const useEventCenter = () => {
  const { taskInfo, events, pageConfig, utils, pageType, taskId, dispatchEvent, destroyEvent, emitEvent } = useMetaStore();
  const { values, setValuesImmediate } = useValuesStore();
  const [eventQiankunState, setEventQiankunState] = useSetState<{
    routeUrl: string;
    eventQiankunVisible: boolean;
  }>({
    eventQiankunVisible: false,
    routeUrl: '',
  });

  let es: EsConfigType[] = [];
  if (pageType === 'add' || pageType === 'edit') {
    es = pageConfig?.createPageConfig?.eventList || [];
  }
  if (pageType === 'view') {
    es = pageConfig?.detailPageConfig?.eventList || [];
  }
  if (pageType === 'list') {
    es = pageConfig?.listPageConfig?.eventList || [];
  }

  const actionCallback: Record<string, any> = {
    copyData: (value: string | number, params: any) => {
      setTimeout(() => {
        onCopyData(value, params);
      }, 1000);
    },
    openUrl: (value: string | number, params: any) => {
      clickUrlFun(value, params);
    },
  };


  useEffect(() => {
    es?.forEach((item) => {
      item.fun = actionCallback[item.actionType];
    });
    dispatchEvent && dispatchEvent(es);

    return () => {
      const destroyIdList = es.map((item) => item.code);
      destroyEvent && destroyEvent(destroyIdList);
    };
  }, [values, pageConfig, pageType]);


  const onCopyData = (value: string | number, { event, type }: FunParamsType) => {
    const resultConfig = es.find((e) => e.code === event.code);

    if (resultConfig?.actionType === 'copyData') {
      // 如果是复制，需要把copyMap仍进去
      const copyMap = pageConfig?.createPageConfig?.copyMap || [];
      resultConfig.copyMap = copyMap.find((cm) => cm.name === resultConfig.copyCode);
    }

    transformCopyValue({ copyConfig: resultConfig?.copyMap, taskInfo, copyId: value, fieldName: resultConfig?.mapField }).then((response) => {
      setValuesImmediate((v) => {
        let pageMergeValue: Record<string, any> = {};
        if (type === 'light') {
          pageMergeValue = _.merge(_.cloneDeep(response), _.cloneDeep(v));
        } else {
          pageMergeValue = _.merge(_.cloneDeep(v), _.cloneDeep(response));
        }
        // 触发event事件 TODO: 当前只触发了头的change事件，并没有触发复制行的change事件
        Object.keys(response).forEach((moduleCode) => {
          const moduleVal = pageMergeValue[moduleCode];
          const controlVal = response[moduleCode];
          if (!_.isArray(controlVal)) {
            Object.keys(controlVal).forEach((fieldCode) => {
              if (event.fieldName == fieldCode && event.moduleName == moduleCode) return;
              emitEvent({ value: moduleVal[fieldCode], moduleName: moduleCode, fieldName: fieldCode, touchConfig: 'change', type });
            });
          }
        });
        return _.merge(v, response);
      });
    });
  };


  const clickUrlFun = (value: string | number, { event, rowIndex, params = {} }: FunParamsType) => {
    const { rowData = {} } = params;
    if (!event) return;
    // 掉用sucess触发微服务中的saveCb
    // utils?.saveSuccess && utils?.saveSuccess();
    const resultConfig = es.find((e) => e.code === event.code);
    const dataSouces = pageType === 'list' ? { [event.moduleName]: rowData } : values;
    let path = '';
    if (event?.toDetailPage && rowData && rowIndex !== undefined) {
      const record = rowData;
      const openVersion = utils?.queryParams?.openVersion === 'true' ? true : undefined;
      path = `/lcp/task/${taskId}/detail/${record?._id}`;
      if (openVersion) {
        path += `?openVersion=true&version=${record.system_version}`;
      }
    } else {
      path = valueReplace(resultConfig?.openUrl, dataSouces, rowIndex);
    }

    if (path && (path.indexOf('ERROR') > -1)) {
      message.error('查看地址错误');
      return;
    }
    const { actionType } = event;
    if (resultConfig?.openType === 'drawer') {
      setEventQiankunState({
        eventQiankunVisible: true,
        routeUrl: path,
      });
      return;
    }
    if (actionType === 'openUrl') {
      utils?.buiNavigate({
        type: resultConfig?.openType || 'tab',
        path,
        title: 'EIMOS',
      });
    }
  };
  return {
    eventQiankunState,
    setEventQiankunState,
  };
};
